const desktopFooterWrap = "nitro-ui__DesktopFooter-module__desktop-footer-wrap";
const desktopFooterLayout = "nitro-ui__DesktopFooter-module__desktop-footer-layout";
const linkTxt = "nitro-ui__DesktopFooter-module__link-txt";
const styles = {
	"desktop-footer-wrap": "nitro-ui__DesktopFooter-module__desktop-footer-wrap",
	desktopFooterWrap: desktopFooterWrap,
	"desktop-footer-layout": "nitro-ui__DesktopFooter-module__desktop-footer-layout",
	desktopFooterLayout: desktopFooterLayout,
	"link-txt": "nitro-ui__DesktopFooter-module__link-txt",
	linkTxt: linkTxt
};

export { styles as default, desktopFooterLayout, desktopFooterWrap, linkTxt };
